import { render, staticRenderFns } from "./hbDec.vue?vue&type=template&id=4f6a8b04&scoped=true"
import script from "./hbDec.vue?vue&type=script&lang=js"
export * from "./hbDec.vue?vue&type=script&lang=js"
import style0 from "./hbDec.vue?vue&type=style&index=0&id=4f6a8b04&prod&lang=scss&scoped=true"
import style1 from "./hbDec.vue?vue&type=style&index=1&id=4f6a8b04&prod&lang=scss&scoped=true"
import style2 from "./hbDec.vue?vue&type=style&index=2&id=4f6a8b04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6a8b04",
  null
  
)

export default component.exports